export const SURVEY_RO_FOOD = 269;

export const FIELD_MAPPING: any = {
    total_food_out: {
        [SURVEY_RO_FOOD]: 'question36',
        default: 'q18'
    },
};

export const getQuestionBySurvey = (surveyId: number, key: string): string => {
    if (FIELD_MAPPING.hasOwnProperty(key)) {
        const params = FIELD_MAPPING[key];

        return params.hasOwnProperty(surveyId) ? params[surveyId] : params.default;
    }

    return key;
}